export const editableFieldsList = [];
export const fieldNameDropDown = [];
export const dropDownMenuUrls = [];
export const reportColumnsDefinitions = [
  {
    label: 'Date',
    field: 'date',
    sign: null,
    width: '120px',
    classes: 'date-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: false,
    visible: false,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Site Name',
    field: 'siteName',
    sign: null,
    width: '120px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Source',
    field: 'sourceName',
    sign: null,
    width: '100px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Ad Group',
    field: 'adGroupName',
    sign: null,
    width: '120px',
    classes: 'adgroup-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Campaign',
    field: 'campaignName',
    sign: null,
    width: '120px',
    classes: 'campaign-column',
    filter: true,
    sort: true,
    format: {
      type: 'string'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Bought',
    field: 'boughtClicks',
    sign: null,
    width: '100px',
    classes: 'bought-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'integer'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'AdCTR',
    field: 'adCtr',
    sign: '%',
    width: '120px',
    classes: 'adctr-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'percentage',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Cost',
    field: 'cost',
    sign: '$',
    width: '100px',
    classes: 'cost-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'float',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'CPC',
    field: 'cpc',
    sign: '$',
    width: '100px',
    classes: 'cpc-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Avg Pos',
    field: 'avgPos',
    sign: null,
    width: '100px',
    classes: 'sold-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'integer'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Sold Total',
    field: 'soldClicks',
    sign: null,
    width: '100px',
    classes: 'sold-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'integer'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Sold',
    field: 'partnerSoldClicks',
    originalField: 'soldClicks',
    sign: null,
    width: '100px',
    classes: 'sold-clicks-partners-column',
    filter: false,
    sort: false,
    format: {
      type: 'integer'
    },
    virtualField: true,
    dynamicField: true,
    checked: true,
    visible: false,
    canBeFixed: false,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Revenue Total',
    field: 'revenue',
    sign: '$',
    width: '120px',
    classes: 'revenue-column',
    filter: true,
    sort: true,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Revenue',
    field: 'partnerRevenue',
    originalField: 'revenue',
    sign: null,
    width: '100px',
    classes: 'revenue-partners-column',
    filter: false,
    sort: false,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    virtualField: true,
    dynamicField: true,
    checked: true,
    visible: false,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'opCTR',
    field: 'opCtr',
    sign: '%',
    width: '120px',
    classes: 'opctr-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'percentage',
      precision: 2
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'RPS',
    field: 'rps',
    sign: '$',
    width: '100px',
    classes: 'rps-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'RPC Total',
    field: 'rpc',
    sign: '$',
    width: '100px',
    classes: 'rpc-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'RPC',
    field: 'partnerRpc',
    originalField: 'rpc',
    sign: '$',
    width: '100px',
    classes: 'rpc-partners-column',
    filter: false,
    sort: false,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: false,
    canBeFixed: true,
    isMetricValue: true,
    virtualField: true,
    dynamicField: true,
    isCompareColumn: false,
  },
  {
    label: 'Profit',
    field: 'profit',
    sign: '$',
    width: '100px',
    classes: 'profit-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'currency',
      precision: 2,
      currency: 'USD'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'TQ',
    field: 'tq',
    sign: null,
    width: '100px',
    classes: 'tq-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'float',
      precision: 2
    },
    checked: true,
    isMetricValue: true,
    visible: true,
    isCompareColumn: false,
  },
  {
    label: 'Conv',
    field: 'conversions',
    sign: null,
    width: '100px',
    classes: 'conversions-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: "integer"
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: true,
    isCompareColumn: false,
  },
  {
    label: 'Labels',
    field: 'adGroupLabels',
    sign: null,
    width: '100px',
    classes: 'sold-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'array'
    },
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  },
  {
    label: 'Status',
    field: 'status',
    sign: null,
    width: '100px',
    classes: 'sold-clicks-column',
    filter: true,
    sort: true,
    format: {
      type: 'custom'
    },
    virtualField: true,
    checked: true,
    visible: true,
    canBeFixed: true,
    isMetricValue: false,
    isCompareColumn: false,
  }
];


// WEBPACK FOOTER //
// ./src/configs/selling-partners-report-config.js